/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicalDataReportAliases {
  LAYOUT_REPORT_MEDICAL_DATA = 'layout-report-medical-data',
  LOADER_PDF = 'loader-pdf',
  PANEL_LOADER = 'panel-loader',
  PANEL_REPORT = 'panel-report',
  PDF_VIEWER = 'pdf-viewer',
}
export { MyChartMedicalDataReportAliases };
